/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const einvoice = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M3.078 4V2.65c0-.967.784-1.75 1.75-1.75h5.176a1.75 1.75 0 0 1 1.336.619l2.639 3.12c.267.315.414.716.414 1.13v7.582a1.75 1.75 0 0 1-1.75 1.75H4.828a1.75 1.75 0 0 1-1.75-1.75V13a.75.75 0 0 1 1.5 0v.352c0 .138.112.25.25.25h7.815a.25.25 0 0 0 .25-.25V5.77a.252.252 0 0 0-.06-.162L10.195 2.49a.25.25 0 0 0-.19-.09H4.827a.25.25 0 0 0-.25.25V4a.75.75 0 1 1-1.5 0Z"
    />
    <path
      fill="#000"
      d="M6.217 8.71c0-1.558-.874-2.546-2.29-2.546-1.377 0-2.327.998-2.327 2.461 0 1.415.95 2.47 2.394 2.47 1.14 0 1.757-.428 2.09-.988l-.893-.618c-.219.285-.504.561-1.188.561-.446 0-.988-.304-1.073-1.007h3.249a1.61 1.61 0 0 0 .038-.333Zm-2.29-1.49c.59 0 .912.342 1.007.969H2.94c.095-.618.428-.969.988-.969Z"
    />
  </svg>
)
export default einvoice
